<template>
  <div class="wrap">
    <transition
      enter-active-class="animate__animated animate__rotateInDownRight"
      leave-active-class="animate__animated animate__rotateOutUpLeft"
      @before-leave="beforeLeave"
    >
      <question
        v-if="questions.length > 0"
        :key="index"
        :id="questions[index].id"
        :question="questions[index].question"
        :answers="questions[index].answer"
        :index="index"
        :sign="sign"
        @end="next"
      />
    </transition>
  </div>
</template>
<script>
// import sma from "@/utils/sma";
import Question from "./Question";
import md5 from "js-md5";
export default {
  components: { Question },
  data() {
    return {
      // 所有的题目
      questions: [],
      // 当前题目的索引
      index: 0,
      // 计时器
      timer: 0,
    };
  },
  computed: {
    sign() {
      return md5(this.$store.state.user.id + new Date().getTime());
    },
  },
  methods: {
    beforeLeave(el) {
      el.classList.add("before-leave");
    },
    // 获取题目
    async getQuestions() {
      try {
        const res = await this.$axios.post(`/Question/getQuestions`);
        this.questions = res?.data ?? [];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.msg || "获取题目发生错误",
          duration: 2000,
        });
        this.$router.replace(`/`);
        console.log(error);
      }
    },
    // 下一题
    next() {
      if (this.questions.length === 0) {
        return;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.index === this.questions.length - 1) {
          // 游戏结束
          clearTimeout(this.timer);
          this.$router.replace(`/question/result?type=1&sign=${this.sign}`);
          return;
        }
        this.index++;
      }, 1000);
    },
  },
  created() {
    if (
      this.$store.state.user &&
      this.$store.state.user.nickname &&
      this.$store.state.user.province_code &&
      this.$store.state.user.province_code !== "0"
    ) {
      this.getQuestions();
    } else {
      this.$notify({
        type: "warning",
        message: "未授权",
        duration: 3000,
        onClose: () => {
          this.$router.replace("/");
        },
      });
      return;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  @include content-bg;

  padding: 64px 20px 20px;
  overflow: hidden;
  @include safe-area-bottom(20px);

  .before-leave {
    position: absolute;
    right: 20px;
    left: 20px;
  }
}
</style>
